var render = function render(){
  var _vm$item, _vm$item2, _vm$item3, _vm$item4, _vm$item5;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('PageHeader', {
    attrs: {
      "pageHeaderBackgroundImageSrc": (_vm$item = _vm.item) === null || _vm$item === void 0 ? void 0 : _vm$item.mainImage,
      "hasOverlay": true,
      "headerBackgroundOpacity": 0.7
    }
  }, [_c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": (_vm$item2 = _vm.item) === null || _vm$item2 === void 0 ? void 0 : _vm$item2.title
    }
  }), _vm.blogPage ? _c('router-link', {
    attrs: {
      "to": {
        name: _vm.isRecentBlogs === 'true' ? 'blog' : 'blogArchives',
        query: {
          blogPage: _vm.blogPage,
          query: _vm.query
        }
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4'
    }
  }, [_vm._v(" " + _vm._s(_vm.isRecentBlogs === 'true' ? "Read All Recent Blogs" : "Read All Archive Blogs") + " ")])], 1) : _c('router-link', {
    attrs: {
      "to": {
        name: 'cybercorner'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4'
    }
  }, [_vm._v(" Back to Cyber Corner ")])], 1)], 1)], 1), _c('b-modal', {
    ref: "my-like-modal",
    attrs: {
      "size": "lg",
      "hide-footer": "",
      "centered": "",
      "title": "Want to Like this post?"
    }
  }, [_c('p', {
    staticClass: "my-1"
  }, [_vm._v(" Please "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login',
        query: {
          redirect: this.$route.path,
          queryString: this.queryString,
          queryValue: this.queryValue
        }
      }
    }
  }, [_c('a', [_vm._v("LOGIN")])]), _vm._v(" or "), _c('router-link', {
    attrs: {
      "to": {
        name: 'signup'
      }
    }
  }, [_c('a', [_vm._v("SIGN UP")])]), _vm._v(" to like content. ")], 1)]), _c('b-modal', {
    ref: "my-modal",
    attrs: {
      "size": "lg",
      "hide-footer": "",
      "centered": "",
      "title": "Want to bookmark this for later?"
    }
  }, [_c('p', {
    staticClass: "my-4"
  }, [_vm._v(" Please "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login',
        query: {
          redirect: this.$route.path,
          queryString: this.queryString,
          queryValue: this.queryValue
        }
      }
    }
  }, [_c('a', [_vm._v("LOGIN")])]), _vm._v(" or "), _c('router-link', {
    attrs: {
      "to": {
        name: 'signup'
      }
    }
  }, [_c('a', [_vm._v("SIGN UP")])]), _vm._v(" to bookmark content. ")], 1)]), _c('SocialMediaWidgets', {
    attrs: {
      "title": _vm.title,
      "description": _vm.description,
      "type": 'blogs-top',
      "isSocialMediaSiblingsVisible": true
    }
  }, [_c('div', {
    staticClass: "col-6 col-lg-3 col-xl-3 p-0"
  }, [_c('p', {
    staticClass: "post-snippet text-start"
  }, [_vm._v(_vm._s((_vm$item3 = _vm.item) === null || _vm$item3 === void 0 ? void 0 : _vm$item3.author))])]), _c('div', {
    staticClass: "col-6 col-lg-3 col-xl-3 p-0"
  }, [_c('p', {
    staticClass: "post-snippet text-right text-lg-left text-xl-left"
  }, [_vm._v(_vm._s(_vm.getFormattedDate((_vm$item4 = _vm.item) === null || _vm$item4 === void 0 ? void 0 : _vm$item4.date)))])]), _c('div', {
    staticClass: "col-6 col-lg-3 col-xl-3 p-0 mt-2 mt-lg-0 mt-xl-0"
  }, [_c('p', {
    staticClass: "post-snippet text-start text-lg-left text-xl-left"
  }, [_vm._v("Cyber Security")])])]), _c('section', {
    staticClass: "section-content"
  }, [_c('div', {
    staticClass: "container my-3 px-3 px-lg-0 px-xl-0"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s((_vm$item5 = _vm.item) === null || _vm$item5 === void 0 ? void 0 : _vm$item5.article)
    }
  })])]), _c('SocialMediaWidgets', {
    attrs: {
      "title": _vm.title,
      "description": _vm.description,
      "type": 'blogs-bottom',
      "isSocialMediaSiblingsVisible": true,
      "hasBottomMargin": true,
      "socialShareColumnClass": 'col-12',
      "socialShareFlexJustifyClass": _vm.socialMediaFlexJustify
    }
  }, [_c('div', {
    staticClass: "col-12 col-lg-9 col-xl-9 p-0 d-flex flex-row justify-content-center justify-content-lg-start justify-content-xl-start"
  }, [_c('div', {
    staticClass: "d-flex flex-row justify-content-between",
    style: {
      'width': _vm.bottomRowLikesBookmarksWidth
    }
  }, [_c('div', {
    staticClass: "mr-4",
    on: {
      "click": function ($event) {
        return _vm.initiateLike();
      }
    }
  }, [this.liked === false ? _c('FlatIconButton', {
    attrs: {
      "label": "Like",
      "icon": "mdi mdi-thumb-up-outline"
    }
  }) : _vm._e(), this.liked === true ? _c('FlatIconButton', {
    attrs: {
      "label": "Liked",
      "icon": "mdi mdi-thumb-up"
    }
  }) : _vm._e()], 1), _c('p', {
    staticClass: "social-button-area-left-text"
  }, [_c('span', {
    staticClass: "mr-4"
  }, [_vm._v(_vm._s(_vm.likeText))])]), !_vm.isPageBookmarked ? _c('div', {
    staticClass: "pl-1 bookmark-page",
    on: {
      "click": _vm.onBookmarkPage
    }
  }, [_c('div', {
    attrs: {
      "id": "tooltip-bookmark"
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": ['far', 'bookmark']
    }
  }), _vm._v(" Bookmark ")], 1), _c('b-tooltip', {
    attrs: {
      "variant": "primary",
      "target": "tooltip-bookmark"
    }
  }, [_vm._v("Click to bookmark page")])], 1) : _c('div', {
    staticClass: "pl-1 bookmark-page",
    on: {
      "click": _vm.onBookmarkPage
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "id": "tooltip-bookmark",
      "icon": ['fas', 'bookmark']
    }
  }), _vm._v(" Bookmarked "), _c('b-tooltip', {
    attrs: {
      "variant": "success",
      "target": "tooltip-bookmark"
    }
  }, [_vm._v("Bookmarked!")])], 1)])])]), _c('section', {
    staticClass: "section-content"
  }, [_c('div', {
    staticClass: "container mb-5 my-3 px-3 px-lg-0 px-lg-0 px-xl-0"
  }, [_c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-12 col-lg-6 col-xl-6 p-0 mb-lg-0 mb-xl-0 d-flex flex-row justify-content-center justify-content-lg-start justify-content-xl-start",
    class: _vm.previousButtonMarginBottomClass
  }, [_vm.previousBlogId ? _c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4',
      "width": "240"
    },
    on: {
      "click": function () {
        return _vm.goToPreviousOrNextBlogItem(_vm.previousBlogId, '#/blogdetail');
      }
    }
  }, [_vm._v(" Read Previous ")]) : _vm._e()], 1), _c('div', {
    staticClass: "col-12 col-lg-6 col-xl-6 p-0 mt-lg-0 mt-xl-0 d-flex flex-row justify-content-center justify-content-lg-end justify-content-xl-end",
    class: _vm.nextButtonMarginTopClass
  }, [_vm.nextBlogId ? _c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4',
      "width": "240"
    },
    on: {
      "click": function () {
        return _vm.goToPreviousOrNextBlogItem(_vm.nextBlogId, '#/blogdetail');
      }
    }
  }, [_vm._v(" Read Next ")]) : _vm._e()], 1)])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }